module.exports = __webpack_public_path__ + "static/media/me.62c3f529.png";